import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface ILoginStrings extends LocalizedStringsMethods {
    lsSubmitTxt: string;
    lsSignInTxt: string;
    lsFooterCopyrightTxt: string;
    lsLoginFailedTxt: string;
    lsAccountIDPlaceholderTxt: string;
    lsPasswordPlaceholderTxt: string;
    lsMobileNoPlaceholderTxt: string;
    lsOTPPlaceholderTxt: string;
    lsOTPResentTxt: string;
    lsOTPResentSuccess: string;
    lsOTPMaxLimitTxt: string;
    lsLinkExpired: string;
    IsUserActive: string;
    lsExternalLoginFailedTxt: string;
    lsExternalLoginFailedTxt2: string;
    lsContactTxt: string;
    lsForgotPasswordTxt: string;
    lsPrivacyPolicyTxt: string;
    lsTermsTxt: string;
    lsRememberMeTxt: string;
    lsAccountIdTxt: string;
    lsSignInTitle: string;
    lsTwoStepTxt: string;
    lsEnterCode: string;
    lsLinkExpr: string;
    lsExpiredLinkMsg: string;
    lsOtpExpiredTxt: string;
    lsOtpErrorTxt: string;
    lsEmailErrorTxt: string;
    lsPhoneErrorTxt: string;
}

let strings: ILoginStrings;
export default strings = new LocalizedStrings({
    en: {        
        lsSubmitTxt: 'Submit',
        lsSendOTP: 'Send Verification Code',
        lsSignInTxt: 'Sign in',
        lsFooterCopyrightTxt: `Copyright © ${new Date().getFullYear()} EyeGuide, Inc.`,
        lsLoginFailedTxt: 'Login failed',
        lsAccountIDPlaceholderTxt: 'Username',
        lsPasswordPlaceholderTxt: 'Password',
        lsMobileNoPlaceholderTxt: 'Mobile Phone #',
        lsOTPPlaceholderTxt: 'Enter Verification Code',
        lsOTPResentTxt: 'Resend Verification Code',        
        lsOTPResentSuccess: 'Verification Code resent successfully',
        lsOTPMaxLimitTxt: 'Maximum Limit of Code Generation Reached.You must login using recently generated Code',
        lsLinkExpired: 'Link has expired',
        IsUserActive: 'This share has been deactivated',
        lsExternalLoginFailedTxt: 'EXTERNAL log in failed',
        lsExternalLoginFailedTxt2: 'Log in failed!',
        lsContactTxt: 'Contact EyeGuide',
        lsForgotUsernameTxt: 'Forgot Username?',
        lsForgotPasswordTxt: 'Forgot Password?',
        lsPrivacyPolicyTxt: 'Privacy Policy',
        lsTermsTxt: 'Terms',
        lsRememberMeTxt: 'Remember Me',
        lsAccountIdTxt: 'Username',
        lsSignInTitle: 'Sign in to EyeGuide',
        lsTwoStepTxt: 'Two-Step Verification',
        lsEnterCode: 'Enter the code sent to your mobile phone',
        lsLinkExpr: 'Link Expired',
        lsExpiredLinkMsg: 'Your share link has now expired. ' + 
                'Please contact {0} {1} of {2}',
        lsOtpExpiredTxt: 'Verification Code has expired!',
        lsOtpErrorTxt: 'Failed to generate Verification Code!',
        lsEmailErrorTxt: 'Invalid email address. Please contact EyeGuide administrator.',
        lsPhoneErrorTxt: 'Invalid phone number. Please contact EyeGuide administrator.'
    },
    es: {        
        lsSubmitTxt: 'Enviar',
        lsSendOTP: 'Enviar móvil',
        lsSignInTxt: 'Registrarse',
        lsFooterCopyrightTxt: 'Copyright y copia; 2018 EyeGuide, Inc.',
        lsLoginFailedTxt: 'error de inicio de sesion',
        lsAccountIDPlaceholderTxt: 'ID de la cuenta',
        lsPasswordPlaceholderTxt: 'Contraseña',
        lsMobileNoPlaceholderTxt: 'Ingrese número móvil',
        lsOTPPlaceholderTxt: 'Ingrese el código móvil',
        lsOTPResentTxt: 'Reenviar código móvil',        
        lsOTPResentSuccess: 'Las contraseñas de un solo uso resienten con éxito',
        lsOTPMaxLimitTxt: 'Límite máximo de generación de OTP alcanzado.\
        Debe iniciar sesión utilizando OTP generado recientemente.',
        lsLinkExpired: 'el link ha expirado',
        IsUserActive: 'This share has been deactivated',
        lsExternalLoginFailedTxt: 'El inicio de sesión EXTERNO falló',
        lsExternalLoginFailedTxt2: '¡Error de inicio de sesion!',
        lsContactTxt: 'Contacto EyeGuide',
        lsForgotUsernameTxt: 'Forgot Username?',
        lsForgotPasswordTxt: 'Se te olvidó tu contraseña?',
        lsPrivacyPolicyTxt: 'Política de privacidad',
        lsTermsTxt: 'Condiciones',
        lsRememberMeTxt: 'Recuérdame',
        lsAccountIdTxt: 'Username',
        lsSignInTitle: 'Sign in to EyeGuide',
        lsTwoStepTxt: 'Verificación de dos pasos',
        lsEnterCode: 'Enter the code sent to your mobile phone',
        lsLinkExpr: 'Link Expired',
        lsExpiredLinkMsg: 'Your share link has now expired',
        lsOtpExpiredTxt: 'One-Time Password has expired!',
        lsOtpErrorTxt: 'Failed to generate One-Time Password!',
        lsEmailErrorTxt: 'Invalid email address. Please contact EyeGuide administrator.',
        lsPhoneErrorTxt: 'Invalid phone number. Please contact EyeGuide administrator.'
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/strings.login.tsx